<p-messages key="info"></p-messages>
<p-toast key="toast" position="top-left" [style]="{marginTop: '80px'}"></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

<div class="card" *ngIf='displayState.workingDiv'>
  <div class="card-body">
    <div class="row" >
      <div class="col-md-12 alert alert-info" style="text-align: center"> Processing, please wait. </div>
    </div>
    <div class="row">
      <div class="col-md-2 offset-5">
        <p-progressSpinner [style]="{width: '100px', height: '100px', margin: '60px'}" strokeWidth="1" fill="#EEEEEE" animationDuration="2.2s"></p-progressSpinner>
      </div>
    </div>
  </div>
</div>


<div class="card bg-light" style="margin-top: 5px;">
  <div class="card-body"style="margin-bottom: 3px;">
    <div class="row">
      <div class="col-md-12 bold" style="text-align: center;"><h4>Statistics Charts</h4></div>
    </div>
    <br />
    <div class="row">
      <div class="col-md-9 offset-1">
        <label for="cmbYear" class="col-form-label">Case Year</label>
        <span style="margin-left: 10px;">
                    <select id="cmbYear" class="col-sm-3" [(ngModel)]='myYear'>
                        <option></option>
                        <option *ngFor="let year of yearList">{{year}}</option>
                    </select>
        </span>
        <span style="margin-left: 10px;">
                    <button class="btn btn-success" title="Click to generate stats and draw charts for selected Roll Year" (click)="runCaseStatsReport()">Generate Case Statistics</button>
        </span>
        <span style="margin-left: 10px;">
                    Chart Type
                    <select [(ngModel)]="chartType" (change)="onChangeType()">
                        <option>line</option>
                        <option>bar</option>
                        <option>pie</option>
                    </select>
        </span>
        <span style="margin-left: 20px;">
                    Calc
                    <select [(ngModel)]="calcType" (change)="onChangeCalc()">
                        <option>count</option>
                        <option>percent</option>
                    </select>
        </span>
        <span hidden style="margin-left: 100px;">
                    <button class="btn btn-info" title="Click to export case data to Excel" (click)="exportExcel()">Export</button>
        </span>
      </div>
    </div>
  </div>
</div>

<div *ngIf='displayState.chartDiv'>
  <div class="row container">
    <div class="col-md-12">
      <p-chart #myChart [type]="chartType" [data]="dynoChartData" [options]="basicOptions" width="90vw" height="60vh" (onDataSelect)="selectData($event)"></p-chart>
    </div>
  </div>
  <div class="row container" *ngIf='displayState.tfDiffDiv'>
    <div class="col-md-12">
      <p-chart #myChartTF type="bar" [data]="tfDiffData" [options]="timeframeChartOptions" width="90vw" height="60vh" (onDataSelect)="selectTFData($event)">
      </p-chart>
    </div>
  </div>
  <hr />
</div>

